/*
Copyright 2025 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const BookmarkIcon = ({ width = 24, height = 24, hidden = false, title = 'Bookmark' } = {}):
  | string
  | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    width="${width}"
    height="${height}"
    viewBox="0 0 20 20"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path
      d="M5.25098,18.99974c-.16016,0-.32227-.03125-.47754-.0957-.46973-.19336-.77344-.64746-.77344-1.15527V4.24974c0-1.24023,1.00977-2.25,2.25-2.25h7.5c1.24023,0,2.25,1.00977,2.25,2.25v13.49902c0,.50781-.30371.96191-.77344,1.15527-.4707.19531-1.00488.08691-1.36328-.27441l-3.86328-3.88672-3.86328,3.88672c-.24023.24219-.55957.37012-.88574.37012ZM6.25,3.49974c-.41309,0-.75.33691-.75.75v12.89258l3.43555-3.45605c.57031-.57227,1.55957-.57129,2.12793-.00098l3.43652,3.45703V4.24974c0-.41309-.33691-.75-.75-.75h-7.5Z"
      fill="currentColor"
      stroke-width="0"
    />
  </svg>`;
};
